import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import "react-tooltip/dist/react-tooltip.css";
import { Tooltip } from "react-tooltip";
import {
  GrayTooltip,
  InfoIcon,
  IndigoTooltip,
  indigoInfoIcon,
  WarningInfoIcon,
  DarkGrayInfoIcon,
} from "assets/img";

function TooltipNew({
  tooltipText,
  id,
  color,
  backgroundColor,
  textColor,
  place,
  whiteIcon,
  grayIcon,
  indigoIcon,
  indigoInfIcon,
  warningInfoIcon,
  darkGrayIcon,
}) {
  return (
    <>
      <div className="flex px-1 cursor-pointer items-center" id={id}>
        {whiteIcon ? (
          <img
            src={InfoIcon}
            style={{ width: "16px", height: "16px" }}
            alt={id}
            layout="fixed"
            data-class="my-tooltip"
            data-html={true}
          />
        ) : grayIcon ? (
          <img
            src={GrayTooltip}
            style={{ width: "16px", height: "16px" }}
            data-class="my-tooltip"
            alt={id}
          />
        ) : indigoIcon ? (
          <img
            src={IndigoTooltip}
            style={{ width: "16px", height: "16px" }}
            data-class="my-tooltip"
            alt={id}
          />
        ) : indigoInfIcon ? (
          <img
            src={indigoInfoIcon}
            style={{ width: "16px", height: "16px" }}
            data-class="my-tooltip"
            alt={id}
          />
        ) : warningInfoIcon ? (
          <img
            src={WarningInfoIcon}
            style={{ width: "16px", height: "16px" }}
            data-class="my-tooltip"
            alt={id}
          />
        ) : darkGrayIcon ? (
          <img
            src={DarkGrayInfoIcon}
            style={{ width: 16, height: 16 }}
            data-class="my-tooltip"
            alt={id}
          />
        ) : (
          <FontAwesomeIcon
            icon={faExclamationCircle}
            color={color ? color : "#000"}
            size="sm"
            style={{ width: "16px", height: "16px" }}
            className="small-icon"
            data-class="my-tooltip"
          />
        )}
      </div>

      <Tooltip
        id={id}
        className="tooltip w-auto text-left z-[1000]"
        anchorSelect={`#${id}`}
        place={place ? place : "right"}
        html={tooltipText}
        style={{
          color: textColor ? textColor : "#fff",
          backgroundColor: backgroundColor ? backgroundColor : "#000",
        }}
      />
    </>
  );
}
export default TooltipNew;
